import { Component } from '@angular/core';

@Component({
  selector: 'quotely-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
}
